<template lang="pug">
  section(class="separable")
    div.marginTop(class="container")
      el-row
        el-col(:span="24")
          el-card(class="card")
            h4.card-title Resultado da pesquisa
            div(class="card-body")
              el-row
                .divider
              .table-pointer
                el-table(
                  :data="cadastros"
                  :default-sort = "{ prop: 'id', order: 'descending' }",
                  @sort-change="sort",
                  style="cursor: pointer"
                )
                  el-table-column(
                    min-width="20"
                  )
                  div(v-if="this.tipo !== 'PERIODO'")
                    el-table-column(
                      v-if="this.tipo === 'MUNICIPIOS'"
                      label='Municípios',
                      min-width="200",
                      prop="label"
                    )
                    el-table-column(
                      v-else-if="this.tipo === 'ORDENS_SERVICO'"
                      label='Ordens de serviço',
                      min-width="200",
                      prop="label"
                    )
                    el-table-column(
                      v-else="this.tipo === 'CADASTRANTE'"
                      label='Cadastrante',
                      min-width="200",
                      prop="label"
                    )
                    el-table-column(
                      sortable,
                      label='Quantidade',
                      min-width="200",
                      prop="valor"
                  )
                  div(v-if="this.tipo === 'PERIODO' && this.tipoPeriodo === 'DIARIO'")
                    el-table-column(
                      label='Período diário',
                      min-width="125",
                      prop="label"
                    )
                    el-table-column(
                      sortable,
                      label='Quantidade',
                      min-width="125",
                      prop="valor"
                    )
                  div(v-if="this.tipo === 'PERIODO' && this.tipoPeriodo === 'MENSAL'")
                    el-table-column(
                      label='Período mensal',
                      min-width="125",
                      prop="label"
                    )
                    el-table-column(
                      sortable,
                      label='Quantidade',
                      min-width="125",
                      prop="valor"
                    )
                  div(v-if="this.tipo === 'PERIODO' && this.tipoPeriodo === 'ANUAL'")
                    el-table-column(
                      label='Período anual',
                      min-width="125",
                      prop="label"
                    )
                    el-table-column(
                      sortable,
                      label='Quantidade',
                      min-width="125",
                      prop="valor"
                    )

            div(class="card-footer") Quantidade total: {{total}}

</template>

<script>

export default {
  props: {
    cadastros: {
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    tipoPeriodo: {
      type: String
    },
    total: {
      type: Number,
      required: true
    }
  },

  methods: {
    sort (data) {
      const ordenacaoFiltro = {
        ordenacao: 'Quantidade',
        tipo: ''
      }

      if (data.order === 'ascending') {
        ordenacaoFiltro.tipo = 'ASC'
      } else {
        ordenacaoFiltro.tipo = 'DESC'
      }

      this.$emit('sort', { ...ordenacaoFiltro })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.button {
  padding: 10px;
}
.card-footer {
  padding: 0 23px;
  margin: 0 10px 10px;
}
.card-title {
  padding-left: 23px;
  margin-bottom: 0;
}
.card {
  margin: 0 0 23px;
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_reurb/components/TabelaPrincipal.vue